// Modules
import React from 'react';

export default function SingleMatchHistoryPlayer(props){
    return(

        <tr className="history-player-row">
            <th className="th-player">{props.gamertag}</th>
            <th className="score">{props.teeScore_01}</th>
            <th className="score">{props.teeScore_02}</th>
            <th className="score">{props.teeScore_03}</th>
            <th className="score">{props.teeScore_04}</th>
            <th className="score">{props.teeScore_05}</th>
            <th className="score">{props.teeScore_06}</th>
            <th className="score">{props.teeScore_07}</th>
            <th className="score">{props.teeScore_08}</th>
            <th className="score">{props.teeScore_09}</th>
            <th className="score">{props.teeScore_10}</th>
            <th className="score">{props.teeScore_11}</th>
            <th className="score">{props.teeScore_12}</th>
            <th className="score">{props.teeScore_13}</th>
            <th className="score">{props.teeScore_14}</th>
            <th className="score">{props.teeScore_15}</th>
            <th className="score">{props.teeScore_16}</th>
            <th className="score">{props.teeScore_17}</th>
            <th className="score">{props.teeScore_18}</th>
            <th className="th-total">Total: {props.scoreTotal}</th>
        </tr>
    );
}


// WEBPACK FOOTER //
// ./src/comps/singleMatchHistoryPlayer.js